export default __webpack_public_path__ + "static/media/Lato-Italic.cba01a7e.ttf";